import React, { useState } from "react";
import { Box, Button, Card, CardContent, TextField, Typography, InputAdornment, CircularProgress, Alert, Link } from "@mui/material";
import Colors from "../libs/Colors.js";
import Signinlogo from "../../assets/signinlogo.png";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { hosturl } from "../libs/Constant.js";

const VerifyOtpPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: location.state?.email || "",
    otp: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [redirectCountdown, setRedirectCountdown] = useState(5);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleVerifyOtp = async () => {
    if (!formData.otp) {
      setError("Please enter the verification code.");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${hosturl}/api/ebooster/auth/verify-signup`, {
        email: formData.email,
        otp: formData.otp,
      });

      if (response.status === 201) {
        setSuccessMessage("Your account has been verified successfully!");
        
        // Start countdown for automatic redirect
        const interval = setInterval(() => {
          setRedirectCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              navigate("/");
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
        
      } else {
        setError("Invalid verification code. Please try again.");
      }
    } catch (error) {
      setError(error.response?.data?.message || "An error occurred while verifying. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        background: "linear-gradient(to bottom, #44A08D, #E4DDEF)",
        height: '100vh',
        overflowY: 'auto',
      }}
    >
      {/* Left Side - Image & Gradient */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px", md: "0" },
        }}
      >
        <img
          src={Signinlogo}
          alt="Illustration"
          style={{ width: "80%", height: "auto" }}
        />
      </Box>

      {/* Right Side - Login Form */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "20px", md: "40px" },
          backgroundColor: 'white',
          borderStartStartRadius: '120px',
          borderBottomLeftRadius: '120px',
        }}
      >
        <Card
          sx={{
            width: { xs: "95%", sm: "380px" },
            padding: "30px",
            boxShadow: "none",
            borderRadius: "16px",
            border: "1px solid #ddd",
            marginX: "20px",
          }}
        >
          <CardContent>
            <Typography 
              variant="h5" 
              align="center" 
              gutterBottom 
              fontWeight={600} 
              sx={{ marginBottom: '20px', color: '#333' }}
            >
              Verify Your Identity
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                marginBottom: "20px",
                textAlign: "center",
                color: '#666'
              }}
            >
              For your security, we've sent a 6-digit verification code to your registered email address.
            </Typography>
            
            <TextField
        fullWidth
        label="Enter OTP"
        variant="standard"
        name="otp"
        value={formData.otp}
        onChange={handleChange}
        sx={{ marginBottom: "8px" }}
      />
            <Button
              variant="contained"
              fullWidth
              sx={{ 
                background: Colors.buttonColor, 
                borderRadius: "8px", 
                textTransform: "none",
                padding: "10px",
                fontWeight: 500,
                marginTop: "8px"
              }}
              onClick={handleVerifyOtp}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Verify Code"
              )}
            </Button>
            
            {error && (
              <Alert 
                severity="error" 
                sx={{ marginTop: "20px", borderRadius: "8px" }}
              >
                {error}
              </Alert>
            )}
            
            {successMessage && (
              <Box sx={{ mt: 2 }}>
                <Alert 
                  severity="success" 
                  sx={{ borderRadius: "8px" }}
                >
                  {successMessage} Please login to continue.
                </Alert>
                <Typography variant="body2" sx={{ mt: 1, textAlign: 'center', color: '#666' }}>
                  {redirectCountdown > 0 ? (
                    `Redirecting to login in ${redirectCountdown} seconds...`
                  ) : (
                    "Redirecting now..."
                  )}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, textAlign: 'center' }}>
                    <Typography>if you are not redirected automatically</Typography>
                  <Link 
                    href="#" 
                    onClick={() => navigate("/")}
                    sx={{ color: Colors.buttonColor, fontWeight: 500 }}
                  >
                    Click here 
                  </Link>
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default VerifyOtpPage;